import serviceClient from "./serviceClient";
import featureFlags from "./featureFlags";

const defaultLanguageSid = "2a803d80-de6d-4adc-a642-4e3d831f5460";
/**
 * keep track of labels viewed in current session
 * 'll need to send them if user decides to update default labels
 */
let viewedLabels = [];
let labels;

getViewedLabels();

//init() gets called in /src/config.js before any single-spa app is loaded
async function init() {
  let aminuteago = new Date();
  aminuteago.setMinutes(aminuteago.getMinutes() - 1);

  console.log(aminuteago);

  if (localStorage.getItem("translatedLabels")) {
    let lastCached = localStorage.getItem("translatedLabelDate");
    if (lastCached && new Date(lastCached) > aminuteago) {
      return JSON.parse(localStorage.getItem("translatedLabels"));
    }
  }
  const tenantClient = await serviceClient.getClient("tenant");
  const translationEnhancements = await featureFlags.checkFeatureFlag(
    "translationEnhancements"
  );

  // if loggedIn
  let response;
  let currentUser = sessionStorage.getItem("currentUser");
  if (currentUser) currentUser = JSON.parse(currentUser);
  if (currentUser && currentUser.tenant) {
    console.log("getting labels for logged-in user");

    response = await tenantClient.apis.translations.listLabels({
      tenant: currentUser.tenant,
      languageSid: currentUser.LanguageID,
    });
  } else {
    // if not loggedIn
    console.log("getting default labels for tenant");
    const tenant = await getTenantIdFromHost(tenantClient);

    if (tenant) {
      if (translationEnhancements) {
        let languages = [];
        const languagesResponse = await tenantClient.apis[
          "tenant"
        ].listTenantLanguages({ tenant });

        if (languagesResponse && languagesResponse.body) {
          languages = languagesResponse.body;

          const language = languages.find(
            (lang) => navigator.language == lang.translationCode
          );

          response = await tenantClient.apis.translations.listLabels({
            tenant,
            languageSid: language?.sid || defaultLanguageSid,
          });
        }
      } else {
        response = await tenantClient.apis.translations.listLabels({
          tenant,
          languageSid: defaultLanguageSid,
        });
      }
    }
  }
  if (response && response.data) {
    labels = JSON.parse(response.data);
    if (translationEnhancements) {
      labels = labels.map((l) => {
        delete l.createdDate;
        delete l.createdBy;
        delete l.modifiedDate;
        delete l.modifiedBy;
        delete l._id;
        delete l.languageName;
        delete l.languageSid;
        delete l.translationCode;
        delete l.__v;
        delete l.language;
        delete l.pack;
        delete l.id;
        return l;
      });
      console.log("storing labels in localStorage");
      localStorage.setItem("translatedLabels", JSON.stringify(labels));
      localStorage.setItem("translatedLabelDate", new Date().toISOString());

      return labels;
    }
    console.log("storing labels in localStorage");
    localStorage.setItem("translatedLabels", response.data);
    localStorage.setItem("translatedLabelDate", new Date().toISOString());
  }

  return labels;
}
function getLocalLabel(key) {
  if (!key) return "";
  let tenant = localStorage.getItem("tenant");
  let labelQa = "";
  if (tenant && tenant == "integrifydev") labelQa = "";

  // add to viewedLabels
  addViewedLabel(key);

  // if (labels && typeof labels === 'object') {

  //   let label = this.localLabelsCache.get(key);
  //   if (label) return label;

  //   label = labels[key] || key;
  //   this.localLabelsCache.set(key, label);
  //   return label;
  // }
  if (!labels) {
    try {
      labels = JSON.parse(localStorage.getItem("translatedLabels")) || [];
    } catch (e) {
      labels = [];
    }
  }

  if (labels) {
    let translatedLabel = labels.find((l) => l.defaultText === key);

    if (translatedLabel) {
      return translatedLabel.translatedText.concat(labelQa);
    }
  }

  return key.concat(labelQa);
}

// saveDefaultList() {
//   return http.post(`${this.baseUrl}/labels/restore-default`, viewedLabels)
//     .then(result => {
//       this.resetViewedLabels();
//       return result.data;
//     })
// }

function getViewedLabels() {
  try {
    viewedLabels = JSON.parse(localStorage.getItem("viewed-labels")) || [];
  } catch (e) {
    viewedLabels = [];
  }
}
// resetViewedLabels() {
//   viewedLabels = [];
//   localStorage.setItem('viewed-labels', JSON.stringify(viewedLabels));
// }
function addViewedLabel(key) {
  // if already in viewedLabels
  if (viewedLabels.includes(key)) return;

  // if already exists in labels
  if (labels && labels[key]) return;

  viewedLabels.push(key);
  localStorage.setItem("viewed-labels", JSON.stringify(viewedLabels));
}

async function getTenantIdFromHost(tenantClient) {
  try {
    let hostname;

    hostname = location.hostname;
    hostname = hostname.toLowerCase();
    const result = await tenantClient.apis.tenant.getTenantLoginSettings({
      hostHeader: hostname,
    });
    const tenant = JSON.parse(result.data);

    if (tenant && tenant.ID) {
      return tenant.ID;
    }
    return null;
  } catch (err) {
    //console.error(err);
    return null;
  }
}

export default {
  init,
  getLocalLabel,
  localLabel: getLocalLabel,
};
